import {NolimitPromotionPlugin} from "@nolimitcity/promo-panel/bin/NolimitPromotionPlugin";
import {KarenGameConfig} from "../KarenGameConfig";
import {KarenPromoPanelConfig} from "../../KarenPromoPanelConfig";
import {Karen} from "../Karen";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";

export class KarenNolimitPromotionPlugin extends NolimitPromotionPlugin {
    constructor(actionSpins: KarenPromoPanelConfig) {
        super(actionSpins);
    }

    close(isFeatureBuy?: boolean): void {
        super.close(isFeatureBuy);
        if (SlotGame.apiPlugin.betHandler.betBoost !== undefined) {
            Karen.reel2Frame.updateLayout(1, false);
        } else {
            Karen.reel2Frame.updateLayout(0, false);
        }
        KarenGameConfig.IS_FEATURE_BUY = isFeatureBuy ? isFeatureBuy : false;
    }
}